import { Component, ViewChild } from '@angular/core';
import { PTicketService } from '../../../services/p-ticket.service';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { pTicket } from '../../../interfaces/pTicket';
import { filter } from 'rxjs';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortable, MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { openSnackBar } from '../../../helpers/genericFunctions';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { PTicketFilterComponent } from '../p-ticket-filter/p-ticket-filter.component';

import { MatTableExporterModule } from 'mat-table-exporter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { report } from '../../../interfaces/preport';
import { MatDialog } from '@angular/material/dialog';
import { PTicketFilterPresetComponent } from '../p-ticket-filter-preset/p-ticket-filter-preset.component';
import { NewReportDialogComponent } from '../../reporting/new-report-dialog/new-report-dialog.component';
import { MatTabsModule, MatTabBody } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListItem } from '@angular/material/list';
import { PTicketNewComponent } from '../p-ticket-new/p-ticket-new.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderTitleService } from '../../../services/header-title.service';
import { SocketService } from '../../../services/socket.service';
import { OrganizationService } from '../../../services/organization.service';
import { globalUser } from '../../../helpers/globalFields';
import { MasterDataService } from '../../../services/master-data.service';
export interface Chip {
  selected: Boolean;
  value: string;
  display: string;
}
@Component({
  selector: 'app-p-ticket-list',
  standalone: true,
  imports: [
    NgFor,
    FormsModule,
    CommonModule,
    MatTableModule,
    RouterModule,
    MatSortModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatChipsModule,
    MatCheckboxModule,
    MatCardModule,
    DragDropModule,
    MatTableExporterModule,
    PTicketFilterComponent,
    MatButtonModule,
    NgxSkeletonLoaderModule,
    MatIconModule,
    MatTabsModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatTooltipModule,
  ],
  templateUrl: './p-ticket-list.component.html',
  styleUrl: './p-ticket-list.component.scss',
})
export class PTicketListComponent {
  constructor(
    private pTicketService: PTicketService,
    private headerTitleService: HeaderTitleService,
    private socketService: SocketService,
    private organizationService: OrganizationService,
    private masterDataService: MasterDataService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
  ) {}
  pTicketsList: pTicket[] = [];

  @ViewChild('pccSort') pccSort!: MatSort;
  @ViewChild('tccSort') tccSort!: MatSort;
  @ViewChild('pccPaginator', { read: MatPaginator })
  pccPaginator!: MatPaginator;
  @ViewChild('tccPaginator', { read: MatPaginator })
  tccPaginator!: MatPaginator;

  @ViewChild('ticketFilter') ticketFilter!: PTicketFilterComponent;

  pccDataSource = new MatTableDataSource(this.pTicketsList);
  tccDataSource = new MatTableDataSource(this.pTicketsList);

  pccSearchbarEntry: string = '';
  tccSearchbarEntry: string = '';
  private readonly LS_PCC_COLS = 'pccDisplayedColumns';
  private readonly LS_TCC_COLS = 'tccDisplayedColumns';
  pccDisplayedColumns: string[] = [
    'id',
    'pct_user',
    'pct_initialdescription',
    'actions',
  ];
  tccDisplayedColumns: string[] = [
    'id',
    'pct_user',
    'pct_initialdescription',
    'actions',
  ];

  currentUser = globalUser;
  emptyPTicket: pTicket = {
    id: 1,
    pct_status: '',
    pct_tickettype: '',
    pct_supportlevel: '',
    pct_useremail: '',
    pct_user: '',
    pct_company: '',
    pct_product: '',
    pct_initialdescription: '',
    pct_callbacknumber: '',
    pct_responsename: '',
    pct_responseemail: '',
    pct_countrycode: '',
    pct_issuetype: '',
    pct_severity: '',
    pct_component: '',
    pct_status_granulated: '',
    pct_system_version: '',
    pct_has_solution: 'false',
    pct_author: '',
    pct_creator: '',
  };
  report!: report;
  loadingPTicket: pTicket[] = [
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
    this.emptyPTicket,
  ];
  loadingPTicketDataSource = new MatTableDataSource(this.loadingPTicket);
  allColumns: string[] = [
    'pct_organization',
    'id',
    'pct_useremail',
    'pct_user',
    'pct_company',
    'pct_product',
    'pct_initialdescription',
    'pct_callbacknumber',
    'pct_responsename',
    'pct_responseemail',
    'pct_status_granulated',
    'pkeywordsflat',
    'pct_countrycode',
    'actions',
  ];
  allDisplays: string[] = [
    'Organization',
    'Ticket Id',
    'User mail',
    'Username',
    'Company',
    'Product',
    'Description',
    'Callback phone',
    'Contact',
    'Contact mail',
    'Granulated Status',
    'Keywords',
    'Country',
    'Actions',
  ];

  Chips!: Chip[];

  tccChips!: Chip[];
  pccChips!: Chip[];

  isLoading: boolean = true;
  tccList!: any;
  pccList!: any;

  protected globalUser = globalUser;

  allOrganizations: any[] = [];

  canCreateTicket: boolean= false;
  canMoveTicket: boolean = false;
  ngAfterViewInit(): void {
    const startDate = new Date('2023-01-01T00:00:00.000Z');
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    const httpParams: HttpParams = new HttpParams()
      .append('pct_tickettype', 'pCC')
      .append('pct_status', 'open')
      .append('updatedAt[$gte]', startDate.toISOString())
      .append('updatedAt[$lte]', endDate.toISOString());

    this.pTicketService.getAll(httpParams).subscribe((res) => {
      let value = res.length;
      if (value == 0) {
        this.headerTitleService.setTitle('Tickets');
      } else {
        this.headerTitleService.setTitle('Tickets (' + value + ')');
      }
    });
  }

  ngOnInit(): void {
    // React to organization changes
    this.organizationService.currentOrg$.subscribe((org) => {
      if (org && this.router.url.startsWith('/pTickets/list')) {
        // Reload the table whenever org changes
        this.initTableData(this.route.snapshot.queryParams);
      }


    });

    this.masterDataService.getMasterOrganizationList().subscribe(
      response => {
        this.allOrganizations = response;
      }
    )

    globalUser.getUserStream().subscribe((user) => {
      if (user) {
        this.canCreateTicket = globalUser.validatePermission('ticket.create');
        this.canMoveTicket = globalUser.validatePermission('ticket.move');
      }
    });
    // Also react to query params changes
    this.route.queryParams.subscribe((params) => {
      this.initTableData(params);
    });

    this.socketService.onValueChanged().subscribe((value) => {
      if (value == 0) {
        this.headerTitleService.setTitle('Tickets');
      } else {
        this.headerTitleService.setTitle('Tickets (' + value + ')');
      }
    });

    this.socketService.onTicketOpened().subscribe((value) => {
      if (value == 0) {
        this.headerTitleService.setTitle('Tickets');
      } else {
        this.headerTitleService.setTitle('Tickets (' + value + ')');
      }
    });

    this.tccChips = [];
    this.pccChips = [];

    this.pccDisplayedColumns = [
      'id',
      'pct_user',
      'pct_initialdescription',
      'actions',
    ];
    this.tccDisplayedColumns = [
      'id',
      'pct_user',
      'pct_initialdescription',
      'actions',
    ];

    const savedPccCols = localStorage.getItem(this.LS_PCC_COLS);
    const savedTccCols = localStorage.getItem(this.LS_TCC_COLS);

    if (savedPccCols) {
      this.pccDisplayedColumns = JSON.parse(savedPccCols);
      const cols: string[] = JSON.parse(savedPccCols);
      this.pccChips.forEach(
        (chip) => (chip.selected = cols.includes(chip.value)),
      );
    }

    if (savedTccCols) {
      this.tccDisplayedColumns = JSON.parse(savedTccCols);
      const cols: string[] = JSON.parse(savedTccCols);
      this.tccChips.forEach(
        (chip) => (chip.selected = cols.includes(chip.value)),
      );
    }
    this.initTableFilters();

    this.route.queryParams.subscribe((params) => {
      let httpParams = new HttpParams();
      const activeFiltersForComponent: { key: any; value: string }[] = [];

      Object.keys(params).forEach((key) => {
        const val = params[key];
        if (Array.isArray(val)) {
          val.forEach((v) => {
            httpParams = httpParams.append(key, v);
            const filterOption = this.ticketFilter?.filterOptions.find(
              (f) => f.db_key === key,
            );
            if (filterOption)
              activeFiltersForComponent.push({ key: filterOption, value: v });
          });
        } else {
          httpParams = httpParams.set(key, val);
          const filterOption = this.ticketFilter?.filterOptions.find(
            (f) => f.db_key === key,
          );
          if (filterOption)
            activeFiltersForComponent.push({ key: filterOption, value: val });
        }
      });

      // Pass activeFilters to filter component
      if (this.ticketFilter)
        this.ticketFilter.activeFilters = activeFiltersForComponent;

      // Load the table
      this.initTableData(httpParams);
    });
  }

  getDisplayName(col: string): string {
    const i = this.allColumns.indexOf(col);
    return this.allDisplays[i] || col;
  }

  onAddReport(report?: report): void {
    const dialogRef = this.dialog.open(NewReportDialogComponent, {
      data: { report: this.report },
      maxWidth: '800px',
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result: report | undefined) => {
      if (result) {
        this.router.navigate([`/reporting/overview`]);
      }
    });
  }

  onNewTicket(listtype: string): void {
    const dialogRef = this.dialog.open(PTicketNewComponent, {
      data: { pct_tickettype: listtype },
      maxWidth: '800px',
      panelClass: 'custom-dialog-container',
    });
  }

  onMoveToOrg(data: pTicket, org: string) {
    this.pTicketService
      .move(data.id, { pct_organization: org })
      .subscribe((res) => {
        this.ngOnInit();
      });
  }

  applyFilter(event: Event, target: MatTableDataSource<any, any>) {
    const filterValue = (event.target as HTMLInputElement).value;
    target.filter = filterValue.trim().toLowerCase();
  }

  removeChip(chip: any, event: MouseEvent) {
    this.tccChips = this.tccChips.filter((c) => c !== chip);
  }

  onEdit(id: number): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/pTicket/${id}`]),
    );

    window.open(url, '_blank');
  }

  onDuplicateTicket(ticket: pTicket): void {
    let duplicateTicket: any = {
      pct_supportlevel: '1',
      pct_status: ticket.pct_status,
      pct_tickettype: ticket.pct_tickettype,
      pct_user: ticket.pct_user,
      pct_responsename: ticket.pct_responsename,
      pct_company: ticket.pct_company,
      pct_countrycode: ticket.pct_countrycode,
      pct_callbacknumber: ticket.pct_callbacknumber,
      pct_responseemail: ticket.pct_responseemail,
      pct_useremail: ticket.pct_useremail,
      pct_initialdescription:
        'This ticket was duplicated from ticket ' + ticket.id,
    };
    this.pTicketService.create(duplicateTicket).subscribe((data) => {
      this.onEdit(data.id);
    });
  }

  initTableFilters() {
    for (let i = 0; i < this.allColumns.length; i++) {
      if (this.pccDisplayedColumns.includes(this.allColumns[i])) {
        this.pccChips.push({
          selected: true,
          value: this.allColumns[i],
          display: this.allDisplays[i],
        });
      } else {
        this.pccChips.push({
          selected: false,
          value: this.allColumns[i],
          display: this.allDisplays[i],
        });
      }
    }
    for (let i = 0; i < this.allColumns.length; i++) {
      if (this.tccDisplayedColumns.includes(this.allColumns[i])) {
        this.tccChips.push({
          selected: true,
          value: this.allColumns[i],
          display: this.allDisplays[i],
        });
      } else {
        this.tccChips.push({
          selected: false,
          value: this.allColumns[i],
          display: this.allDisplays[i],
        });
      }
    }
  }

  initTableData(filterInput: HttpParams | Record<string, string | string[]>) {
    let httpParams: HttpParams;

    let filterObj: Record<string, string | string[]>;

    if (filterInput instanceof HttpParams) {
      // Directly use HttpParams for API call
      httpParams = filterInput;

      // Convert HttpParams to plain object for URL
      filterObj = {};
      filterInput.keys().forEach((key) => {
        const vals = filterInput.getAll(key);
        if (vals) filterObj[key] = vals.length === 1 ? vals[0] : vals;
      });
    } else {
      // Build HttpParams from plain object
      filterObj = filterInput;
      httpParams = new HttpParams();
      Object.keys(filterObj).forEach((key) => {
        const value = filterObj[key];
        if (Array.isArray(value)) {
          value.forEach((v) => (httpParams = httpParams.append(key, v)));
        } else {
          httpParams = httpParams.set(key, value);
        }
      });
    }

    // Convert HttpParams to plain object
    const queryObj: Record<string, string | string[]> = {};
    httpParams.keys().forEach((key) => {
      const vals = httpParams.getAll(key);
      if (vals) queryObj[key] = vals.length === 1 ? vals[0] : vals;
    });

    // Update URL with plain object
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryObj,
    });

    this.report = {
      id: -1,
      rep_title: 'New Report',
      rep_chartType: 'bar',
      rep_xAxisOption: { key: 'pct_has_solution', label: 'Has Solution' },
      rep_filter: httpParams,
    };
    this.isLoading = true;
    this.pTicketService.getAll(httpParams).subscribe((pTicketsList) => {
      // after the TicketList has been loaded, load the tickets into the tables
      this.pTicketsList = pTicketsList;

      this.pTicketsList = pTicketsList.map((ticket) => ({
        ...ticket,
        pkeywordsflat:
          ticket.pkeywords?.map((k) => k.pkw_value).join(', ') || '',
      }));

      //pcc tableview
      this.pccSort.sort({} as MatSortable);
      this.pccSort.sort({ id: 'id', start: 'desc' } as MatSortable);
      this.pccDataSource = new MatTableDataSource(
        this.pTicketsList.filter((pTicket) => pTicket.pct_tickettype === 'pCC'),
      );
      this.pccDataSource.sort = this.pccSort;
      this.pccDataSource.paginator = this.pccPaginator;
      this.pccDataSource.filter = this.pccSearchbarEntry.trim().toLowerCase();

      //tcc tableview
      this.tccSort.sort({} as MatSortable);
      this.tccSort.sort({ id: 'id', start: 'desc' } as MatSortable);
      this.tccDataSource = new MatTableDataSource(
        this.pTicketsList.filter((pTicket) => pTicket.pct_tickettype === 'tCC'),
      );
      this.tccDataSource.sort = this.tccSort;
      this.tccDataSource.paginator = this.tccPaginator;
      this.tccDataSource.filter = this.tccSearchbarEntry.trim().toLowerCase();

      this.isLoading = false;
      // filter test
    });
  }

  toggleSelection(table: string, chip: Chip) {
    chip.selected = !chip.selected;

    if (table === 'pcc') {
      this.pccDisplayedColumns = this.pccChips
        .filter((c) => c.selected)
        .map((c) => c.value);

      localStorage.setItem(
        this.LS_PCC_COLS,
        JSON.stringify(this.pccDisplayedColumns),
      );
    }

    if (table === 'tcc') {
      this.tccDisplayedColumns = this.tccChips
        .filter((c) => c.selected)
        .map((c) => c.value);

      localStorage.setItem(
        this.LS_TCC_COLS,
        JSON.stringify(this.tccDisplayedColumns),
      );
    }
  }

  onMoveTotCC(ticket: pTicket) {
    this.pTicketService
      .update(ticket.id, { pct_tickettype: 'tCC' })
      .subscribe((res) => {
        this.ngOnInit();
      });
  }
}
